import classNames from 'classnames'

import { useStickyShadow } from '../../../hooks'
import { SelectionToolbarContent } from '../../SelectionToolbar'

import * as styles from './TableModalSelectionToolbar.module.css'

function TableModalSelectionToolbar({
  exclude,
  pagination,
  selectAllPages,
  selected,
  ...restProps
}) {
  const { isStuck, ref: stickyRef } = useStickyShadow()

  return (
    <div
      className={classNames(styles.TableModalSelectionToolbar, {
        [styles.shadow]: isStuck,
      })}
      ref={stickyRef}
    >
      <SelectionToolbarContent
        {...restProps}
        allSelected={selectAllPages || selected.length === pagination.count}
        count={pagination.count}
        excludeCount={exclude.length}
        selected={selected.length}
      />
    </div>
  )
}

export default TableModalSelectionToolbar
